import React from "react";
import { useSelector } from "react-redux";

import { IStickyNavItem } from "../../../Models/IStickyNavItem";
import ReportStickyNav from "../../Common/ReportComponents/ReportStickyNav";
import { colorNine } from "../../../globalStyles";
import { gpsShowVisitorBehaviors } from "../../../Reducers/Selectors/GPSInsightsSelectors";

interface IGPSStickyNav {
  stuckClass?: string;
  isSharing?: boolean;
  isScout?: boolean;
}

const getNavItems = (showVisitorBehaviors: boolean, isSharing?: boolean, isScout?: boolean): IStickyNavItem[] => {
    const standardOffset = (isSharing || !isScout) ? -50: -110;
    const navItems: IStickyNavItem[] = [
        {
            toComponent: "GPSTradeArea",
            title: "Trade Area",
            offset: -500,
            color: colorNine,
        },
        {
            toComponent: "GPSHHChar",
            title: "Household Characteristics",
            offset: standardOffset,
            color: colorNine,
        },
        {
            toComponent: "GPSVolume",
            title: "Volume",
            offset: standardOffset,
            color: colorNine,
        },
    ];

    if (showVisitorBehaviors) {
        navItems.push({
            toComponent: "GPSVisBeh",
            title: "Visitor Behaviors",
            offset: standardOffset,
            color: colorNine,
        });
    }

    return navItems;
};

const GPSStickyNav = (props: IGPSStickyNav): JSX.Element => {
    /** selectors */
    const showVisitorBehaviorsComponent: boolean = useSelector(gpsShowVisitorBehaviors);

    return (
        <ReportStickyNav
            id="GPSStickyNav"
            containerId="GPSReportBody"
            stuckClass={props.stuckClass}
            stickyNavItems={getNavItems(showVisitorBehaviorsComponent, props.isSharing, props.isScout)}
        />
    );
};

export default GPSStickyNav;
